import React from 'react';
import { IQuestionElementProps } from '../../interface';
import { QuestionInput } from '../questionInput';
import { If } from 'common/src/components';
import { internalList } from '../../../templateInfo/dataFlow';
import { optionExternalList } from '../../dataFlow';
import { QuestionOperateType, VIEW_MODE } from '../../../../interface/multiCapabilityTemplate';
import { lang } from '@umu/ukit-lang';
import { QuestionResource } from '../../../questionResource';
import { onTransformNumberToChart } from '../../../../dataFlow/multiCapabilityTemplate';
import { OtherOption, IOtherOptionInfo } from './otherOption';
import { AdvanceOption, IAdvanceOptionInfo } from './advanceOption';
const defaultOption = {};

interface IProps extends IQuestionElementProps {
    multiple?: boolean;
}

const RadioOptionInfo = (props: IProps) => {
    const {
        info: { list = [], extend = { setup: {} } },
        multiple = false,
        mode,
        preCls = 'template-question',
    } = props;
    const isView = mode === VIEW_MODE.VIEW;
    const onUpdateList = (list: any[]) => {
        return props.onCommunication(QuestionOperateType.CHANGE_CONFIG, { ...props.info, list });
    };
    const onOptionCommunication = (act: QuestionOperateType, data: any, index: number) => {
        const newList = [...list];
        switch (act) {
            case QuestionOperateType.CHANGE_CONFIG:
                newList[index] = {
                    ...newList[index],
                    ...data,
                };
                break;
            case QuestionOperateType.OPTION_ADD:
                // index 后面插入一条
                newList.splice(index + 1, 0, {
                    ...defaultOption,
                    index: list.length + 1,
                    id: '',
                    desc: '',
                    weights: 0,
                    type: 0,
                    title: '',
                } as any);
                break;
            case QuestionOperateType.OPTION_DELETE:
                if (newList.length > 1) {
                    newList.splice(index, 1);
                }
                break;
            case QuestionOperateType.UPDATE_IMG:
                newList[index] = {
                    ...newList[index],
                    extend: {
                        ...list[index]?.extend,
                        resource_arr: data?.resourceInfo
                            ? [
                                  {
                                      resource_type: 11,
                                      resource_id: '',
                                      resource_data: data.resourceInfo,
                                  },
                              ]
                            : [],
                    },
                } as any;
                break;
            default:
                break;
        }
        return onUpdateList(newList);
    };
    const renderList = () => {
        const showList = isView ? list : list.filter((item) => !item?.type);
        return showList.map((item, index) => {
            const prefix = isView ? (
                <div className={`question-option-prefix ${multiple ? 'box' : 'circle'}`} />
            ) : (
                `${onTransformNumberToChart(index)}.`
            );
            return (
                <li key={item.index || index} className={`${preCls}-option-item`}>
                    <div>
                        <QuestionInput
                            preCls={`${preCls}-input`}
                            value={item.title}
                            prefix={prefix}
                            placeholder={lang('点击创建选项，回车自动创建下一个选项')}
                            externalList={optionExternalList}
                            internalList={internalList}
                            onPressEnter={() =>
                                !item.title &&
                                onOptionCommunication(QuestionOperateType.OPTION_ADD, {}, showList.length - 1)
                            }
                            onFocus={() =>
                                !item.title &&
                                onOptionCommunication(QuestionOperateType.OPTION_ADD, {}, showList.length - 1)
                            }
                            onCommunication={(act, data) => onOptionCommunication(act, data, index)}
                        ></QuestionInput>
                        <If condition={(item?.extend?.resource_arr || [])?.length > 0}>
                            <QuestionResource
                                list={item?.extend?.resource_arr || []}
                                isALlowDelete
                                className="rows-split"
                                onUpdateResourceList={(list) =>
                                    onOptionCommunication(
                                        QuestionOperateType.CHANGE_CONFIG,
                                        {
                                            extend: {
                                                ...item.extend,
                                                resource_arr: list,
                                            },
                                        },
                                        index,
                                    )
                                }
                            />
                        </If>
                    </div>
                </li>
            );
        });
    };

    const onOtherOptionChange = (data: IOtherOptionInfo) => {
        if (!data.isShow) {
            const newList = list.filter((item) => !item?.type);
            onUpdateList(newList);
            return;
        }
        const otherOption: any = list.find((item) => !!item?.type);
        if (!otherOption) {
            onUpdateList([
                ...list,
                {
                    ...defaultOption,
                    index: list.length,
                    id: '',
                    desc: '',
                    type: 1,
                    title: lang('其他'),
                    extend: {
                        setup: {
                            require: '1',
                        },
                    },
                },
            ]);
            return;
        }
        otherOption.title = data.title;
        otherOption.extend.setup.require = data.isRequired;
        onUpdateList(list);
    };
    const renderExternalContent = () => {
        const otherOption = list.find((item) => !!item?.type);
        const optionInfo = {
            title: otherOption?.title || '',
            isShow: !!otherOption,
            isRequired: String(otherOption?.extend?.setup.require || 1),
        };
        return isView ? null : <OtherOption info={optionInfo} onChange={onOtherOptionChange} />;
    };
    const onAdvanceChange = (data: IAdvanceOptionInfo) => {
        const setup = {
            require: '0',
            limit_options_min: '',
            limit_options_max: '',
        };
        setup.require = data.isRequire;
        setup.limit_options_min = String(data.range[0]);
        setup.limit_options_max = String(data.range[1]);
        props.onCommunication(QuestionOperateType.CHANGE_CONFIG, {
            ...props.info,
            extend: { ...extend, setup: { ...extend?.setup, ...setup } },
        });
    };
    const renderAdvanceContent = () => {
        const setup: any = extend?.setup || {};
        const advanceInfo: any = {
            isRequire: String(setup?.require || 0),
            range: [setup?.limit_options_min || 0, setup?.limit_options_max || 0],
            optionCount: list.length,
        };
        return <AdvanceOption isView={isView} multiple={multiple} info={advanceInfo} onChange={onAdvanceChange} />;
    };
    return (
        <div className={`${preCls}-radio`}>
            <ul className={`${preCls}-option`}>{renderList()}</ul>
            <div className={`${preCls}-option-external`}>{renderExternalContent()}</div>
            <div className={`${preCls}-option-advance`}>{renderAdvanceContent()}</div>
        </div>
    );
};
export { RadioOptionInfo };
